import { User } from './user';

export class AdminUser extends User {
    
    supervisor: AdminUser;
    
    constructor() {
        super();
        this["@type"] = "AdminUser";

    }
}
